export default __webpack_public_path__ + "static/media/11-6.b9c24a08.png";